import { produce } from 'immer';
import { ExtendedHipaaSetupAction, HipaaSetupAction, HipaaSetupState } from './hipaa-types';
import {
  HIPAA_SETUP_INIT_MODAL,
  HIPAA_SETUP_NEXT_STEP,
  HIPAA_SETUP_CAPTURE_STEP_DATA,
  HIPAA_SETUP_DISABLE_STEP,
  HIPAA_SETUP_REQUEST,
  HIPAA_SETUP_REQUEST_SUCCESS,
  HIPAA_SETUP_REQUEST_ERROR,
  HIPAA_SETUP_NOT_STARTED,
  HIPAA_SETUP_PROCESS_BAA,
  HIPAA_SETUP_SUBMIT_BAA,
  HIPAA_SETUP_SUBMIT_BAA_SUCCESS,
  HIPAA_SETUP_SUBMIT_BAA_ERROR,
  HIPAA_SETUP_PROCESSED_BAA_SUCCESS,
  HIPAA_SETUP_PROCESS_BAA_ERROR,
  HIPAA_SETUP_BAA_FILL_FORM,
  HIPAA_SETUP_BAA_IS_VALID,
  HIPAA_SETUP_GENERIC_ERROR,
  HIPAA_SETUP_MODAL_OPEN_TOGGLE
} from './actions';
import {
  baaFormIsValid,
  captureStepData,
  fillBaaFormField,
  getHipaaSetupSuccess,
  initHipaaSetupModal,
  moveToNextStep,
  setErrorStep,
  toggleHipaaSetupModal
} from './updater';
import { FORM_SAVE_FAILURE, FORM_SAVE_REQUEST } from '../../formeditor/actions';

const initialState: HipaaSetupState = {
  currentStepNo: 1,
  completedSteps: {},
  initialized: false
};

export default function hippaSetupReducer(baseState: HipaaSetupState = initialState, action: HipaaSetupAction) {
  const { type, payload } = action;

  return produce(baseState, (state: HipaaSetupState) => {
    switch (type) {
      case HIPAA_SETUP_INIT_MODAL:
        return initHipaaSetupModal(state);

      case HIPAA_SETUP_NOT_STARTED:
        state.loading = false;
        state.started = false;
        state.currentStepNo = 1;

        return state;

      case HIPAA_SETUP_GENERIC_ERROR:
        return setErrorStep(state, payload);

      case HIPAA_SETUP_REQUEST:
        state.loading = true;
        delete state.errorMessage;

        return state;

      case HIPAA_SETUP_REQUEST_SUCCESS:
        return getHipaaSetupSuccess(state, payload);

      case HIPAA_SETUP_MODAL_OPEN_TOGGLE:
        const isModalOpenPropertyDefined = (action as ExtendedHipaaSetupAction)?.isModalOpen;
        return toggleHipaaSetupModal(state, isModalOpenPropertyDefined);

      case HIPAA_SETUP_REQUEST_ERROR:
        state.loading = false;

        return setErrorStep(state, payload);

      case HIPAA_SETUP_NEXT_STEP:
        return moveToNextStep(payload.stepNo, state);

      case HIPAA_SETUP_CAPTURE_STEP_DATA:
        return captureStepData(payload.stepNo, state, payload.stepData);

      case HIPAA_SETUP_DISABLE_STEP:
        state.stepDisabled = payload.stepDisabled;

        return state;

      case HIPAA_SETUP_BAA_FILL_FORM:
        return fillBaaFormField(payload.baaFieldValue, state);

      case HIPAA_SETUP_BAA_IS_VALID:
        // when the baa form is valid, we want to enable the next button for
        // the current step
        return baaFormIsValid(payload.baaIsValid, state);

      // this looks hacky, but since we're using the form editor
      // to submit the hipaa baa form, we want to start the submission when
      // the form editor starts saving the form
      case FORM_SAVE_REQUEST:
      case HIPAA_SETUP_SUBMIT_BAA:
        state.submitting = true;
        state.submitted = false;
        delete state.errorMessage;

        return state;

      case HIPAA_SETUP_SUBMIT_BAA_SUCCESS:
        state.submitting = false;
        state.submitted = true;
        state.baaPdfUrl = payload.baaPdfUrl;

        return state;

      // likewise here, we want to revert the states when
      // the form fails
      case FORM_SAVE_FAILURE:
      case HIPAA_SETUP_SUBMIT_BAA_ERROR:
        state.submitted = false;
        state.submitting = false;

        return setErrorStep(state, payload);

      case HIPAA_SETUP_PROCESS_BAA:
        state.processed = false;
        state.processing = true;
        state.stepDisabled = true;
        delete state.errorMessage;

        return state;

      case HIPAA_SETUP_PROCESSED_BAA_SUCCESS:
        state.processed = true;
        state.processing = false;
        state.stepDisabled = false;

        return state;

      case HIPAA_SETUP_PROCESS_BAA_ERROR:
        state.processed = false;
        state.processing = false;

        return setErrorStep(state, payload);

      default:
        return state;
    }
  });
}
